import { useApp } from "../store.jsx";
import { fmtMonth } from "../calc.js";

// Checkbox list of gates from the same department; toggling commits via patchTask.
export default function GateDeps({ task }) {
  const { milestones, patchTask } = useApp();
  if (!task) return null;

  const gates = (milestones || [])
    .filter(m => m.deptShort === task.deptShort)
    .sort((a, b) => (a.sortOrder - b.sortOrder) || (a.month - b.month));

  const selected = new Set(task.gateDeps || []);

  const toggle = (id) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id); else next.add(id);
    patchTask(task.id, { gateDeps: [...next] });
  };

  if (gates.length === 0) {
    return (
      <div>
        <h3 style={{margin:"0 0 6px"}}>External gates</h3>
        <div className="sub">No gates defined for {task.deptShort} yet. Add them on the department page.</div>
      </div>
    );
  }

  return (
    <div>
      <h3 style={{margin:"0 0 6px"}}>External gates this task depends on</h3>
      <div className="sub" style={{marginBottom:8}}>
        Selected gates are drawn as dashed arrows from their diamond to this task's start in the Gantt.
      </div>
      <ul className="gate-deps">
        {gates.map(g => (
          <li key={g.id}>
            <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer"}}>
              <input type="checkbox" checked={selected.has(g.id)}
                     onChange={() => toggle(g.id)}
                     style={{accentColor:"var(--milestone)"}}/>
              <span className="diamond"/>
              <span style={{flex:1}}>{g.label}</span>
              <span className="sub">{fmtMonth(g.month)}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}
